import {MAX_DECIMAL_SYMBOLS as TO_POSITION} from 'shared/format';
import {roundDecimal} from '../roundDecimal';

export function toReadable(amount: number): string {
  return roundDecimal(amount, TO_POSITION).toString().replace(/\./g, ',');
}
